import { Typography, Box } from "@mui/material";

export default function CustomerDetailsCard({ customer }) {
  if (!customer) {
    return null;
  }

  const address = [
    [customer.strasse, customer.hausnr].filter(Boolean).join(" "),
    [customer.plz, customer.ort].filter(Boolean).join(" "),
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="h5" gutterBottom>
        Kundeninformationen
      </Typography>
      <Typography>
        <strong>Kundenname:</strong> {customer.display_name}
      </Typography>
      {customer.id_ov && (
        <Typography>
          <strong>OV-ID:</strong> {customer.id_ov}
        </Typography>
      )}
      {customer.anrede && (
        <Typography>
          <strong>Anrede:</strong> {customer.anrede}
        </Typography>
      )}
      {address && (
        <Typography>
          <strong>Adresse:</strong> {address}
        </Typography>
      )}
    </Box>
  );
}
